import { ModalContentTypes } from "../constants/modal-content-types";
import { ModalContentService } from "../modal-content/modal-content.service";

export const openModalWhatsInside = (productName: string, bundleItems: any[], modalContentService: ModalContentService) => {
  const items: string[] = [];
  bundleItems.forEach((item: any) => {
    items.push(`
        <div class="row d-flex justify-content-between p-3 py-1 animated fadeIn">
          <div class="col-8">
            <h6 class="h8-semibold text-start d-flex align-items-center gap-2">${item.name} ${item.packageName ? (' | ' +
        item.packageName) : (item.display ? (' | ' + item.display) : '')}
              ${item?.isPremiumAddon ? `<span class="material-symbols-outlined text-primary h6-size">verified</span>` : ''}
            </h6>
          </div>
          <div class="col-4">
            <h6 class="h8-semibold text-end">${item.quantity}</h6>
          </div>
        </div>
        `);
  });

  modalContentService.openModal(ModalContentTypes.CONFIRMATION, {
    title: productName,
    textContent: `<div class="bg-opacity-10 pt-2 rounded-4">${items.join('')}</div>`,
    confirmButtonText: 'Continue',
  }, { size: 'md' });
}

export const setUpBundleChangesLog = (product: any, newQuantity?: number): BundleChangesLog | undefined => {
  return {
    name: newQuantity ? 'Bundle Quantity Changed' : 'Bundle Customized',
    content: generateBundleHtmlTableFromJson({
      ...product,
      quantity: newQuantity || product.quantity,
    })
  };
}

const generateBundleHtmlTableFromJson = (product: any): string => {

  const { name, quantity, subscription, bundle } = product;
  // Start building the HTML table
  let html = '<table class="table table-bordered o_table" style="width: 50%">';

  // Add general details
  html += `<th colspan="2" style="text-align: center; font-weight: semi-bold">${name}</td></tr>`;
  html += `<tr><td width="50%">Quantity</td><td width="50%">${quantity}</td></tr>`;
  html += `<tr><td width="50%" style="text-transform:capitalize">Subscription</td><td width="50%">${subscription ? `Subscribed ${subscription.frequencyName ?? subscription.frequency.name}${subscription.startDate ? ` from ${subscription.startDate}` : ''}` : 'Non-applicable'}</td></tr>`;

  // Let's sort the bundle items by premium addons first
  const sortedItems = bundle.items.sort((a: any, b: any) => {
    if (a.isPremiumAddon && !b.isPremiumAddon) return -1;
    if (!a.isPremiumAddon && b.isPremiumAddon) return 1;
    return 0;
  });
  // Add bundle items
  if (sortedItems.length) {
    html += '<tr><th colspan="2" class="text-center" style="font-weight: semi-bold">Bundle Items</th></tr>';
    sortedItems.forEach((item: { name: any; quantity: any; isPremiumAddon: boolean; }) => {
      html += `<tr><td width="50%" style="text-transform:capitalize; ${item.isPremiumAddon ? 'font-style: italic; font-weight: bold;' : ''}">${item.name} ${item.isPremiumAddon ? '*' : ''}</td><td width="50%">${item.quantity}</td></tr>`;
    });
  } else {
    html += '<tr><td colspan="2" style="text-align: center; font-style: italic">No Bundle Items</td></tr>';
  }

  // Close the HTML table
  html += '</table>';

  return html;
}

export interface BundleChangesLog {
  name: string;
  content: string;
}